'use client';

// Spec 113 — one-time celebratory onboarding panel shown before the share
// screen on a creator's FIRST successful market creation (FR-016/FR-017).
// Gated by the device-local `useProposalFirstCreationStore` flag in the
// dialog; this component is purely presentational.
import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
interface ProposalFirstCreationPanelProps {
  /** Created market's title, for the celebratory heading. */
  title: string;
  /** "Let's go" → mark seen, then show the share screen. */
  onContinue: () => void;
}
export function ProposalFirstCreationPanel(t0) {
  const $ = _c(31);
  const {
    title,
    onContinue
  } = t0;
  const t = useTranslations("launchpad.form.firstCreation");
  let t1;
  if ($[0] !== t) {
    t1 = t("step1");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("step2");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = [t1, t2];
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const steps = t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="size-1.5 rounded-full bg-feedback-success-accent" aria-hidden="true" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="inline-flex items-center gap-1.5 self-start rounded-full bg-feedback-success-accent/10 px-2.5 py-1 text-caption font-medium uppercase tracking-wider text-feedback-success-content">{t4}{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t || $[13] !== title) {
    t7 = t("subtitle", {
      title
    });
    $[12] = t;
    $[13] = title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <h2 className="text-balance font-bold text-heading-lg leading-tight text-foreground-primary">{t7}</h2>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="flex flex-col gap-2">{t6}{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== steps) {
    t10 = <ol className="flex flex-col gap-2">{steps.map(_temp)}</ol>;
    $[20] = steps;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("cta");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== onContinue || $[25] !== t11) {
    t12 = <AnimatedButton type="button" size="xl" onClick={onContinue} className="w-full">{t11}</AnimatedButton>;
    $[24] = onContinue;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t12 || $[29] !== t9) {
    t13 = <div className="flex flex-col gap-5 motion-safe:animate-in motion-safe:fade-in-0 motion-safe:slide-in-from-bottom-2 motion-safe:duration-normal">{t9}{t10}{t12}</div>;
    $[27] = t10;
    $[28] = t12;
    $[29] = t9;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}
function _temp(copy, index) {
  return <li key={copy} className="flex items-center gap-3 rounded-panel-row border bg-background-secondary px-4 py-3"><span className="flex size-7 shrink-0 items-center justify-center text-body font-semibold tabular-nums text-foreground-tertiary">{index + 1}</span><span className="text-body text-foreground-secondary">{copy}</span></li>;
}